
export enum USER_TYPE {
  FACILITY = "FACILITY", 
  PROVIDER = "PROVIDER" 
}

export interface IShareTribeUserInfo {
  email: string; //ST info
  firstName: string;
  lastName: string;
}

// Admin components import these verification enums from user.interface, but the
// canonical definitions live alongside the provider/facility interfaces. Re-export
// them here (single source of truth) so both import paths resolve to one definition.
export { PROVIDER_VERIFICATION_STAGE, LICENSE_TYPE } from "./provider.interface";
export { FACILITY_VERIFICATION_STAGE } from "./facility.interface";
